import { render } from "./MassReportDashboard.vue?vue&type=template&id=55dfca59&scoped=true"
import script from "./MassReportDashboard.vue?vue&type=script&lang=js"
export * from "./MassReportDashboard.vue?vue&type=script&lang=js"

import "./MassReportDashboard.vue?vue&type=style&index=0&id=55dfca59&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dfca59"]])

export default __exports__